import React from 'react';
import { object } from 'prop-types';
import { Icon } from '@fiverr-private/fit';
import { s_info_circle } from '@fiverr-private/fit/icons';
import { I18n } from '@fiverr-private/fiverr_context';
import SafePureComponent from '../shared/SafePureComponent';
import getDisclaimers from './config';

import './style.scss';

const Disclaimer = (props, { general, pathfinderWrapper }) => {
    const { subCategoryId, nestedSubCategoryId } = general;
    const disclaimers = getDisclaimers(pathfinderWrapper);
    let disclaimerId = null;

    Object.keys(disclaimers).forEach((disclaimer) => {
        if (disclaimer === String(subCategoryId)) {
            disclaimerId = subCategoryId;
        } else if (disclaimer === String(nestedSubCategoryId)){
            disclaimerId = nestedSubCategoryId;
        }
    });

    if (!disclaimerId) {
        return null;
    }

    const { title, description, parseMarkup = false, i18nParams = {} } = disclaimers[disclaimerId];

    return (
        <div className="disclaimer">
            <header>
                <h6><Icon size={12} className="disclaimer-icon">{s_info_circle}</Icon><I18n k={title}/></h6>
            </header>

            <p><I18n k={description} parseMarkup={parseMarkup} params={i18nParams}/></p>
        </div>
    );
};

Disclaimer.contextTypes = {
    general: object,
    pathfinderWrapper: object
};

export { Disclaimer };
export default SafePureComponent(Disclaimer);
